/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { AppState } from "Dataflows/Reducers";
import { ICapDataResult } from "Interfaces/Demographics/ICapDataResult";
import { IDemographicsResult } from "Interfaces/Demographics/IDemographicsResult";
import { IFilterValue } from "Interfaces/IFilterValue";

export const getDemographics = (state: AppState): IDemographicsResult =>
  state.demographicsState.demographicsData;

export const getCapData = (state: AppState): ICapDataResult => state.demographicsState.capData;

export const getDemographicsFilterValues = (state: AppState): IFilterValue[] =>
  state.demographicsState.demographicsFilterValues;

export const getLoadDemographicsError = (state: AppState) =>
  state.demographicsState.loadDemographicsError;

export const getLoadCapDataError = (state: AppState) => state.demographicsState.loadCapDataError;

export const isLoadingDemographics = (state: AppState) =>
  state.demographicsState.isLoadingDemographics;

export const isLoadingCapData = (state: AppState): boolean =>
  state.demographicsState.isLoadingCapData;

export const getCurrentTenant = (state: AppState): string => state.demographicsState.tenant;
